module.exports = __webpack_public_path__ + "img/cross-white.391c06a2.svg";